import { api } from "@/lib/api";

const FINALES = new Set(["processed", "failed", "canceled", "expired", "refunded"]);
const espera = (ms) => new Promise((r) => setTimeout(r, ms));

// Crea la orden en el equipo Point y espera el resultado. cancelRef.current=true pide cancelar.
export async function mpCobrar({ terminalId, monto, onEstado, cancelRef }) {
  const { data: o } = await api.post("/mp-point/orders", { terminal_id: terminalId, amount: Math.round(monto) });
  onEstado?.("Pasa o acerca la tarjeta en el equipo Mercado Pago Point…");
  const fin = Date.now() + 16 * 60 * 1000;
  let cancelPedido = false;
  while (Date.now() < fin) {
    await espera(2500);
    if (cancelRef?.current && !cancelPedido) {
      cancelPedido = true;
      onEstado?.("Cancelando la orden en el equipo…");
      try { await api.post(`/mp-point/orders/${o.order_id}/cancelar`); } catch (e) { /* se reintenta al consultar */ }
    }
    let r;
    try { ({ data: r } = await api.get(`/mp-point/orders/${o.order_id}`)); } catch (e) { continue; }
    if (r.status === "at_terminal") onEstado?.("Esperando que el cliente pague en el equipo…");
    if (FINALES.has(r.status)) {
      return { aprobado: r.status === "processed", ...r,
        mensaje: { failed: "Pago rechazado en el equipo", canceled: "Orden cancelada", expired: "La orden expiró sin pago" }[r.status] || r.status };
    }
  }
  return { aprobado: false, order_id: o.order_id, mensaje: "Tiempo de espera agotado" };
}
